import { getStreak } from '../controllers/stats'
import { SHARE_LINK } from '../config'

type ShareTextArgs = {
	stars: number
	gameNumber: number
	time: number
}

export default function buildShareText({ stars, gameNumber, time }: ShareTextArgs) {
	const seconds = Math.floor(time % 60)
	const mins = Math.floor(time / 60)
	const timeStr = `${mins.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`

	let shareText = `#ows${gameNumber} 🔎 ${stars}/5 (${timeStr})\n`

	if (stars === 5) {
		shareText += '🌟🌟🌟🌟🌟'
	} else {
		shareText += '⭐'.repeat(stars)
	}

	shareText += '\n'

	const streak = getStreak()
	shareText += `🔥 streak: ${streak}\n`

	const game = 'ows'
	if (streak >= 1000) shareText += `😇 #${game}god\n`
	else if (streak >= 750) shareText += `#${game}titan\n`
	else if (streak >= 600) shareText += `🧑‍🎤 #${game}superstar\n`
	else if (streak >= 500) shareText += `👑 #${game}royalty\n`
	else if (streak >= 400) shareText += `🧞 #${game}genius\n`
	else if (streak >= 300) shareText += `🧙 #${game}wizard\n`
	else if (streak >= 250) shareText += `👑 #${game}legend\n`
	else if (streak >= 200) shareText += `🧠 #${game}guru\n`
	else if (streak >= 150) shareText += `🏆 #${game}master\n`
	else if (streak >= 100) shareText += `🌟 #${game}centurion\n`
	else if (streak >= 75) shareText += `💎 #${game}diamondteam\n`
	else if (streak >= 50) shareText += `🥇 #${game}goldteam\n`
	else if (streak >= 25) shareText += `🥈 #${game}silverteam\n`
	else if (streak >= 10) shareText += `🏆 #${game}elite\n`

	shareText += SHARE_LINK || 'onewordsearch.com'

	return shareText
}
